import './style.scss'

export default function Scan() {
  return (
    <div className="com-ad-scan">
      <div className="line" />
    </div>
  )
}
